export const SET_PROJECTS_FOLDERS_TREE = 'SET_PROJECTS_FOLDERS_TREE'
export const SET_GET_PROJECTS_FOLDERS_TREE_PENDING = 'SET_GET_PROJECTS_FOLDERS_TREE_PENDING'
export const SET_CURRENT_PROJECTS_FOLDER = 'SET_CURRENT_PROJECTS_FOLDER'
export const UPDATE_PROJECTS_FOLDERS_TREE = 'UPDATE_PROJECTS_FOLDERS_TREE'
export const SET_PROJECTS_FOLDER_BY_ID_PENDING = 'SET_PROJECTS_FOLDER_BY_ID_PENDING'
export const SET_ROOM_TO_MOVE = 'SET_ROOM_TO_MOVE'
export const SET_MOVE_ROOM_DIALOG_IS_OPEN = 'SET_MOVE_ROOM_DIALOG_IS_OPEN'
export const SET_MOVE_ROOM_PENDING = 'SET_MOVE_ROOM_PENDING'
